// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// const ProviderProfileUpdate = () => {
//   const [services, setServices] = useState([{
//     serviceName: '',
//     amountCharged: '',
//     duration: '',
//     homeService: false,
//     companyName: '',
//     serviceCenter: '',
//     roleRequested:'',
//     yearsExperience: '',
//     images: [],
//     aboutUs: '',
//     bioData: '',
//   }]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     // Optionally fetch existing servicesRendered to prefill
//     const fetchProfile = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/my-requests`, {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//         });
//         const userData = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/my-profile`, {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//         });
//         if (userData.data.servicesRendered?.length) {
//           setServices(userData.data.servicesRendered);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchProfile();
//   }, []);

//   const handleInputChange = (index, field, value) => {
//     const newServices = [...services];
//     newServices[index][field] = value;
//     setServices(newServices);
//   };

//   const handleImageUpload = async (index, files) => {
//     const formData = new FormData();
//     Array.from(files).forEach(file => formData.append('file', file));
//     formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
//     try {
//       const res = await axios.post(
//         `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
//         formData
//       );
//       const newServices = [...services];
//       newServices[index].images.push(res.data.secure_url);
//       setServices(newServices);
//       toast.success('Image uploaded');
//     } catch (err) {
//       toast.error('Upload failed');
//     }
//   };

//   const addService = () => {
//     setServices([...services, {
//       serviceName: '',
//       amountCharged: '',
//       duration: '',
//       homeService: false,
//       companyName: '',
//       roleRequested: '',
//       serviceCenter: '',
//       yearsExperience: '',
//       images: [],
//       aboutUs: '',
//       bioData: '',
//     }]);
//   };

//   const submit = async () => {
//     setLoading(true);
//     try {
//       await axios.put(`${process.env.REACT_APP_API_URL}oosh/service/services`, { servicesRendered: services }, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       toast.success('Profile updated');
//     } catch (err) {
//       toast.error('Update failed');
//     }
//     setLoading(false);
//   };

//   return (
//     <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
//       <h2 className="text-2xl font-bold mb-6 text-blue-600">Update Provider Profile</h2>
//       {services.map((service, index) => (
//         <div key={index} className="mb-6 p-4 border rounded-lg">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

//             <div>
//               <label className="block text-sm font-medium text-gray-700">Service Name</label>
//               <input
//                 type="text"
//                 value={service.serviceName}
//                 onChange={(e) => handleInputChange(index, 'serviceName', e.target.value)}
//                 className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Amount Charged</label>
//               <input
//                 type="number"
//                 value={service.amountCharged}
//                 onChange={(e) => handleInputChange(index, 'amountCharged', e.target.value)}
//                 className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Duration</label>
//               <input
//                 type="text"
//                 value={service.duration}
//                 onChange={(e) => handleInputChange(index, 'duration', e.target.value)}
//                 className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Years of Experience</label>
//               <input
//                 type="number"
//                 value={service.yearsExperience}
//                 onChange={(e) => handleInputChange(index, 'yearsExperience', e.target.value)}
//                 className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Company Name</label>
//               <input
//                 type="text"
//                 value={service.companyName}
//                 onChange={(e) => handleInputChange(index, 'companyName', e.target.value)}
//                 className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//             {/* <div>
//               <label className="block text-sm font-medium text-gray-700">Service Center</label>
//               <input
//                 type="text"
//                 value={service.serviceCenter}
//                 onChange={(e) => handleInputChange(index, 'serviceCenter', e.target.value)}
//                 className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
//               />
//             </div> */}
//               <div>
//     <label className="block text-sm font-medium text-gray-700">Role</label>
//     <select
//       value={service.roleRequested || ''}
//       onChange={(e) => handleInputChange(index, 'roleRequested', e.target.value)}
//       className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
//       required
//     >
//       <option value="" disabled>Select a role</option>
//       <option value="contractor">Contractor</option>
//       <option value="serviceprovider">Service Provider</option>
//       <option value="supplier">Supplier</option>
//     </select>
//   </div>
// </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700">About Us</label>
//               <textarea
//                 value={service.aboutUs}
//                 onChange={(e) => handleInputChange(index, 'aboutUs', e.target.value)}
//                 className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
//                 rows="4"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Bio Data</label>
//               <textarea
//                 value={service.bioData}
//                 onChange={(e) => handleInputChange(index, 'bioData', e.target.value)}
//                 className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
//                 rows="4"
//               />
//             </div>
//             <div className="flex items-center">
//               <label className="block text-sm font-medium text-gray-700 mr-4">Home Service</label>
//               <input
//                 type="checkbox"
//                 checked={service.homeService}
//                 onChange={(e) => handleInputChange(index, 'homeService', e.target.checked)}
//                 className="h-5 w-5 text-blue-600"
//               />
//             </div>
            
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Images</label>
//               <input
//                 type="file"
//                 multiple
//                 onChange={(e) => handleImageUpload(index, e.target.files)}
//                 className="mt-1 p-2 w-full border rounded-md"
//               />
//               <div className="mt-2 flex flex-wrap gap-2">
//                 {service.images.map((img, i) => (
//                   <img key={i} src={img} alt="Service" className="h-20 w-20 object-cover rounded" />
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       ))}
//       <div className="flex gap-4">
//         <button
//           onClick={addService}
//           className="bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600"
//         >
//           Add Another Service
//         </button>
//         <button
//           onClick={submit}
//           disabled={loading}
//           className="bg-green-500 text-white p-2 rounded-md hover:bg-green-600 disabled:opacity-50"
//         >
//           {loading ? 'Saving...' : 'Save Services'}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ProviderProfileUpdate;















import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const ProviderProfileUpdate = () => {
  const [services, setServices] = useState([{
    serviceName: '',
    amountCharged: '',
    duration: '',
    homeService: false,
    companyName: '',
    serviceCenter: '',
    roleRequested: '',
    yearsExperience: '',
    images: [],
  }]);
  const [profile, setProfile] = useState({
    aboutUs: '',
    bioData: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/profile`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        if (res.data.servicesRendered?.length) {
          setServices(res.data.servicesRendered);
        } else {
          setServices([{
            serviceName: '',
            amountCharged: '',
            duration: '',
            homeService: false,
            companyName: '',
            serviceCenter: '',
            roleRequested: '',
            yearsExperience: '',
            images: [],
          }]);
        }
        setProfile({
          aboutUs: res.data.aboutUs || '',
          bioData: res.data.bioData || '',
        });
      } catch (err) {
        console.error('Error fetching profile:', err);
        toast.error('Failed to load profile data');
      }
    };
    fetchProfile();
  }, []);

  const handleInputChange = (index, field, value) => {
    const newServices = [...services];
    newServices[index][field] = value;
    setServices(newServices);
  };

  const handleProfileChange = (field, value) => {
    setProfile({ ...profile, [field]: value });
  };

  const handleImageUpload = async (index, files) => {
    const formData = new FormData();
    Array.from(files).forEach(file => formData.append('file', file));
    formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
    try {
      const res = await axios.post(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
        formData
      );
      const newServices = [...services];
      newServices[index].images.push(res.data.secure_url);
      setServices(newServices);
      toast.success('Image uploaded');
    } catch (err) {
      toast.error('Upload failed');
      console.error(err);
    }
  };

  const addService = () => {
    setServices([...services, {
      serviceName: '',
      amountCharged: '',
      duration: '',
      homeService: false,
      companyName: '',
      serviceCenter: '',
      roleRequested: '',
      yearsExperience: '',
      images: [],
    }]);
  };

  const removeService = (index) => {
    setServices(services.filter((_, i) => i !== index));
  };

  const submit = async () => {
    setLoading(true);
    try {
      // Validate services
      for (const service of services) {
        if (!service.serviceName || !service.amountCharged || !service.duration || !service.yearsExperience) {
          toast.error('Please fill in all required service fields');
          setLoading(false);
          return;
        }
      }

      // Update services
      await axios.put(`${process.env.REACT_APP_API_URL}oosh/service/services`, 
        { servicesRendered: services }, 
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );

      // Update profile
      await axios.put(`${process.env.REACT_APP_API_URL}oosh/service/profile`, 
        { aboutUs: profile.aboutUs, bioData: profile.bioData }, 
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );

      toast.success('Profile and services updated');
    } catch (err) {
      toast.error('Update failed');
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-6 text-blue-600">Update Provider Profile</h2>
      
      {/* Profile Fields */}
      <div className="mb-6 p-4 border rounded-lg">
        <h3 className="text-lg font-semibold mb-4">Profile Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">About Us</label>
            <textarea
              value={profile.aboutUs}
              onChange={(e) => handleProfileChange('aboutUs', e.target.value)}
              className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
              rows="4"
              placeholder="Tell us about your business"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Bio Data</label>
            <textarea
              value={profile.bioData}
              onChange={(e) => handleProfileChange('bioData', e.target.value)}
              className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
              rows="4"
              placeholder="Share your professional background"
            />
          </div>
        </div>
      </div>

      {/* Services */}
      {services.map((service, index) => (
        <div key={index} className="mb-6 p-4 border rounded-lg">
          <h3 className="text-lg font-semibold mb-4">Service {index + 1}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Service Name</label>
              <input
                type="text"
                value={service.serviceName}
                onChange={(e) => handleInputChange(index, 'serviceName', e.target.value)}
                className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Amount Charged</label>
              <input
                type="number"
                value={service.amountCharged}
                onChange={(e) => handleInputChange(index, 'amountCharged', e.target.value)}
                className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Duration</label>
              <input
                type="text"
                value={service.duration}
                onChange={(e) => handleInputChange(index, 'duration', e.target.value)}
                className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Years of Experience</label>
              <input
                type="number"
                value={service.yearsExperience}
                onChange={(e) => handleInputChange(index, 'yearsExperience', e.target.value)}
                className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Company Name</label>
              <input
                type="text"
                value={service.companyName}
                onChange={(e) => handleInputChange(index, 'companyName', e.target.value)}
                className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Service Center</label>
              <input
                type="text"
                value={service.serviceCenter}
                onChange={(e) => handleInputChange(index, 'serviceCenter', e.target.value)}
                className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Role</label>
              <select
                value={service.roleRequested || ''}
                onChange={(e) => handleInputChange(index, 'roleRequested', e.target.value)}
                className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500"
              >
                <option value="" disabled>Select a role</option>
                <option value="contractor">Contractor</option>
                <option value="serviceprovider">Service Provider</option>
                <option value="supplier">Supplier</option>
              </select>
            </div>
            <div className="flex items-center">
              <label className="block text-sm font-medium text-gray-700 mr-4">Home Service</label>
              <input
                type="checkbox"
                checked={service.homeService}
                onChange={(e) => handleInputChange(index, 'homeService', e.target.checked)}
                className="h-5 w-5 text-blue-600"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Images</label>
              <input
                type="file"
                multiple
                onChange={(e) => handleImageUpload(index, e.target.files)}
                className="mt-1 p-2 w-full border rounded-md"
              />
              <div className="mt-2 flex flex-wrap gap-2">
                {service.images.map((img, i) => (
                  <img key={i} src={img} alt="Service" className="h-20 w-20 object-cover rounded" />
                ))}
              </div>
            </div>
          </div>
          {services.length > 1 && (
            <button
              onClick={() => removeService(index)}
              className="mt-4 text-red-500 hover:text-red-700"
            >
              Remove Service
            </button>
          )}
        </div>
      ))}
      <div className="flex gap-4">
        <button
          onClick={addService}
          className="bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600"
        >
          Add Another Service
        </button>
        <button
          onClick={submit}
          disabled={loading}
          className="bg-green-500 text-white p-2 rounded-md hover:bg-green-600 disabled:opacity-50"
        >
          {loading ? 'Saving...' : 'Save Profile'}
        </button>
      </div>
    </div>
  );
};

export default ProviderProfileUpdate;


































